import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { MdMoreHoriz } from "react-icons/md";
import ConfirmPopOver from "../../../../common/ConfirmPopOver";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import SendBadgeModal from "../../../../Modals/SendBadgeModal/SendBadgeModal";

function EventGuestsListItem(props) {
  const { t } = useTranslation();
  const { person, /* callback, */ deletePerson } = props;
  // const [ modalShow, setModalShow ] = useState(false);
  const [badgeModalShow, setBadgeModalShow] = useState(false);

  const onDelete = () => deletePerson(person);

  const DeleteItem = () => (
    <ConfirmPopOver
      placement="left"
      title={t("users.delete_user")}
      onConfirm={onDelete}
      confirmText={t("general.delete")}
      cancelText={t("general.cancel")}
      triggerElement={
        <span className="dropdown-item" style={{ cursor: "pointer" }}>
          {t("general.delete")}
        </span>
      }
    />
  );
  const statusClass = classNames({
    "background-light-gray": person && person.event.personStatus === 0, //To be invited
    "background-pink":
      person &&
      (person.event.personStatus === 1 ||
        person.event.personStatus === 6 ||
        person.event.personStatus === 7), //Not participating || No show || Checked out
    "background-purple": person && person.event.personStatus === 2, //Invited
    "background-green":
      person &&
      (person.event.personStatus === 3 ||
        person.event.personStatus === 5 ||
        person.event.personStatus === 10), //Registered || Checked in || Waiting for approval
    "background-red": person && person.event.personStatus === 4, //Cancelled
    "background-orange": person && person.event.personStatus === 8, //In queue
    "background-black": person && person.event.personStatus === 9, //Waiting for payment
  });

  return (
    <React.Fragment>
      <div
        className="DataListItem row align-items-center"
        key={person.personID}
        style={{ paddingTop: "20px", paddingBottom: "20px" }}
      >
        <div className="col-lg-3">
          <span /*style={{ cursor: 'pointer' }} onClick={() => setModalShow(true)}*/
          >
            <strong>
              {person.firstNames || person.lastName
                ? person.firstNames + " " + person.lastName
                : t("persons.anonymous_person")}
            </strong>
          </span>
        </div>
        <div className="col-lg-3 text-left">
          <span>{person.company || "-"}</span>
        </div>
        <div className="col text-left">
          <span>{person.jobTitle || "-"}</span>
        </div>
        <div className="col-lg-2 text-right">
          <div
            className={`badge status-badge ${statusClass}`}
            style={{ minWidth: 80, color: "white" }}
          >
            {t("person_status." + person.event.personStatus)}
          </div>
        </div>
        <div className="col text-right guest-actions">
          <Dropdown>
            <Dropdown.Toggle as="span">
              <MdMoreHoriz style={{ fontSize: "18px" }} />
            </Dropdown.Toggle>
            <Dropdown.Menu alignRight>
              <Dropdown.Item
                className="send-badge-action"
                onClick={() => setBadgeModalShow(true)}
              >
                {t("persons.send_badge")}
              </Dropdown.Item>
              <Dropdown.Item as={DeleteItem} />
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
      <SendBadgeModal
        eventID={person.event.eventID}
        personID={person.personID}
        show={badgeModalShow}
        onHide={() => setBadgeModalShow(false)}
      />
    </React.Fragment>
  );
}

export default EventGuestsListItem;
